import api from "../axiosIntercepture";

export const getallpartner = async (page, pageSize) => {
    try {
        const response = await api.post(`partner/fetch?limit=${pageSize}&page=${page+1}`,);
        return response.data?.data;
    } catch (err) {
        throw err?.response?.data?.message;
    }
}
export const addPartner = async (userData) => {
    try {
        const response = await api.post("partner/create", userData);
        return response.data?.data;
    } catch (err) {
        throw err?.response?.data?.data;
    }
}
export const updatePartner = async (userData, id) => {
   
    try {
        const response = await api.post(`partner/update/${id}`, userData);
        return response.data?.data;
    } catch (err) {
        throw err?.response?.data?.message;
    }
}

export const create_UpdatePartner=async(data,id)=>{
    try{
const response = await api.post(`partner/create_ExtPartner/${id}`, data);
        return response.data?.data;
    }
    catch(err){
         throw err?.response?.data?.message;
    }
}

export const searchPartner = async (inputValue) => {
    try {
        const response = await api.post(`partner/search?q=${inputValue}`,);
        return response.data?.data;
    } catch (err) {
        throw err?.response?.data?.message;
    }
}